import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ButtonM, Content, Section, TabMenu, TextDiv } from "../styles/Common";
import { styled } from "styled-components";
import InquiryList from "../components/myPage/InquiryList";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";
import EulaTermsText from "../components/signup/EulaTermsText";
import EulaPrivacyText from "../components/signup/EulaPrivacyText";

const UserGuidePage = () => {
  const [currentTab, clickTab] = useState(0);
  const menuArr = [
    { name: "서비스 이용약관", content: <EulaTermsText /> },
    { name: "개인정보처리방침", content: <EulaPrivacyText /> },
  ];

  const selectMenuHandler = (index) => {
    // parameter로 현재 선택한 인덱스 값을 전달해야 하며, 이벤트 객체(event)는 쓰지 않는다
    // 해당 함수가 실행되면 현재 선택된 Tab Menu 가 갱신.
    clickTab(index);
  };
  return (
    <OnlyHeaderLayout title="이용 안내">
      <Section className="nonePaddingTop">
        <Content>
          <TabMenu>
            {menuArr.map((el, index) => (
              <li
                key={index}
                className={index === currentTab ? "pointer focused" : "pointer"}
                onClick={() => selectMenuHandler(index)}
              >
                {el.name}
              </li>
            ))}
          </TabMenu>
          <Desc>{menuArr[currentTab].content}</Desc>
        </Content>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default UserGuidePage;

const Desc = styled.div`
  margin-top: 3rem;
  padding-bottom: 3rem;

  h5 {
    margin-top: 1rem;
  }
  ol {
    margin: 0.5rem 0 0 2.5rem;
    list-style: decimal;
    list-style-type: decimal;
  }
  ul {
    margin: 0.5rem 0 0 1rem;
  }
  li {
    font-size: 0.83em;
  }
  p {
    margin-top: 0.5rem;
    font-size: 0.83em;
  }
  table,
  td,
  th {
    border: 1px solid;
    font-size: 0.83em;
  }
  table {
    margin-top: 1rem;
  }
`;
